import request from '@/utils/request'
import {
  mockFileCenterList,
  mockNotificationList,
  mockSysEntryList,
  mockTodoResponse,
  mockVoiceItem,
  mockVoiceList
} from '@/mock/mockData'

function ok(data) {
  return Promise.resolve({ success: true, data })
}

export function getVoiceList(moduleSelected) {
  const moduleName = moduleSelected && moduleSelected.moduleId !== 0 ? moduleSelected.moduleName : undefined
  const data = mockVoiceList(moduleName)
  return ok({ list: data.list, total: data.total })
}

export function getVoiceItem(id) {
  return ok(mockVoiceItem(id))
}

export function searchVoiceList(moduleSelected, pageNum, pageSize) {
  const moduleName = moduleSelected && moduleSelected.moduleId !== 0 ? moduleSelected.moduleName : undefined
  const data = mockVoiceList(moduleName, pageNum, pageSize)
  return ok({ list: data.list, total: data.total })
}

export function getTodoList(pageNum, pageSize, title) {
  return ok(mockTodoResponse(pageNum, pageSize, undefined, title))
}

export function getNotificationList(pageNum, pageSize) {
  return ok(mockNotificationList(pageNum, pageSize))
}

// 帮助中心
export function getFileList(pageNum, pageSize) {
  return ok(mockFileCenterList(pageNum, pageSize))
}

// 快捷入口
export function getSysList(appCode) {
  return ok(mockSysEntryList(appCode))
}

// 新增快捷入口
export function addSysList(data) {
  return request({
    url: '/sys_entry',
    method: 'post',
    data
  })
}

// 删除快捷入口
export function deleteSysList(id) {
  return request({
    url: '/sys_entry/' + id,
    method: 'delete'
  })
}

// 质量管理列表
export function getApplicationList(appCode) {
  return request({
    url: '/sys_application_public/list?appCode=' + appCode,
    method: 'get'
  })
}

// 获取语言
export function getLanguageList() {
  return ok([
    {
      code: 'zh',
      name: '中文',
      langData: []
    },
    {
      code: 'en',
      name: 'English',
      langData: []
    }
  ])
}
